// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "decco/src/Decco.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as App_Types_Date$DvmAdminFrontendFr from "../../common/types/App_Types_Date.bs.js";

var Fields = {
  year: "year",
  periodID: "periodID",
  rmpc: "rmpc",
  nameRmpc: "nameRmpc",
  mr: "mr",
  nameMr: "nameMr",
  allocatedResources: "allocatedResources",
  finishedRequestsAmount: "finishedRequestsAmount",
  remainingResources: "remainingResources",
  unvalidatableRequestsAmount: "unvalidatableRequestsAmount",
  validatableRequestsAmount: "validatableRequestsAmount",
  validatedRequestsAmount: "validatedRequestsAmount",
  startDate: "startDate",
  endDate: "endDate"
};

function poolExpense_encode(v) {
  return Js_dict.fromArray([
              [
                "year",
                Decco.stringToJson(v.year)
              ],
              [
                "periodID",
                Decco.stringToJson(v.periodID)
              ],
              [
                "rmpc",
                Decco.optionToJson(Decco.stringToJson, v.rmpc)
              ],
              [
                "nameRmpc",
                Decco.optionToJson(Decco.stringToJson, v.nameRmpc)
              ],
              [
                "mr",
                Decco.optionToJson(Decco.stringToJson, v.mr)
              ],
              [
                "nameMr",
                Decco.optionToJson(Decco.stringToJson, v.nameMr)
              ],
              [
                "allocatedResources",
                Decco.optionToJson(Decco.floatToJson, v.allocatedResources)
              ],
              [
                "finishedRequestsAmount",
                Decco.optionToJson(Decco.floatToJson, v.finishedRequestsAmount)
              ],
              [
                "remainingResources",
                Decco.optionToJson(Decco.floatToJson, v.remainingResources)
              ],
              [
                "unvalidatableRequestsAmount",
                Decco.optionToJson(Decco.floatToJson, v.unvalidatableRequestsAmount)
              ],
              [
                "validatableRequestsAmount",
                Decco.optionToJson(Decco.floatToJson, v.validatableRequestsAmount)
              ],
              [
                "validatedRequestsAmount",
                Decco.optionToJson(Decco.floatToJson, v.validatedRequestsAmount)
              ],
              [
                "startDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.startDate)
              ],
              [
                "endDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.endDate)
              ],
              [
                "resourcesToAllocate",
                Decco.optionToJson(Decco.floatToJson, v.resourcesToAllocate)
              ]
            ]);
}

function poolExpense_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var year = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "year"), null));
  if (year.TAG === /* Ok */0) {
    var periodID = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "periodID"), null));
    if (periodID.TAG === /* Ok */0) {
      var rmpc = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rmpc"), null));
      if (rmpc.TAG === /* Ok */0) {
        var nameRmpc = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "nameRmpc"), null));
        if (nameRmpc.TAG === /* Ok */0) {
          var mr = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mr"), null));
          if (mr.TAG === /* Ok */0) {
            var nameMr = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "nameMr"), null));
            if (nameMr.TAG === /* Ok */0) {
              var allocatedResources = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "allocatedResources"), null));
              if (allocatedResources.TAG === /* Ok */0) {
                var finishedRequestsAmount = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "finishedRequestsAmount"), null));
                if (finishedRequestsAmount.TAG === /* Ok */0) {
                  var remainingResources = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "remainingResources"), null));
                  if (remainingResources.TAG === /* Ok */0) {
                    var unvalidatableRequestsAmount = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "unvalidatableRequestsAmount"), null));
                    if (unvalidatableRequestsAmount.TAG === /* Ok */0) {
                      var validatableRequestsAmount = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "validatableRequestsAmount"), null));
                      if (validatableRequestsAmount.TAG === /* Ok */0) {
                        var validatedRequestsAmount = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "validatedRequestsAmount"), null));
                        if (validatedRequestsAmount.TAG === /* Ok */0) {
                          var startDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "startDate"), null));
                          if (startDate.TAG === /* Ok */0) {
                            var endDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "endDate"), null));
                            if (endDate.TAG === /* Ok */0) {
                              var resourcesToAllocate = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resourcesToAllocate"), null));
                              if (resourcesToAllocate.TAG === /* Ok */0) {
                                return {
                                        TAG: /* Ok */0,
                                        _0: {
                                          year: year._0,
                                          periodID: periodID._0,
                                          rmpc: rmpc._0,
                                          nameRmpc: nameRmpc._0,
                                          mr: mr._0,
                                          nameMr: nameMr._0,
                                          allocatedResources: allocatedResources._0,
                                          finishedRequestsAmount: finishedRequestsAmount._0,
                                          remainingResources: remainingResources._0,
                                          unvalidatableRequestsAmount: unvalidatableRequestsAmount._0,
                                          validatableRequestsAmount: validatableRequestsAmount._0,
                                          validatedRequestsAmount: validatedRequestsAmount._0,
                                          startDate: startDate._0,
                                          endDate: endDate._0,
                                          resourcesToAllocate: resourcesToAllocate._0
                                        }
                                      };
                              }
                              var e = resourcesToAllocate._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".resourcesToAllocate" + e.path,
                                        message: e.message,
                                        value: e.value
                                      }
                                    };
                            }
                            var e$1 = endDate._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".endDate" + e$1.path,
                                      message: e$1.message,
                                      value: e$1.value
                                    }
                                  };
                          }
                          var e$2 = startDate._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".startDate" + e$2.path,
                                    message: e$2.message,
                                    value: e$2.value
                                  }
                                };
                        }
                        var e$3 = validatedRequestsAmount._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".validatedRequestsAmount" + e$3.path,
                                  message: e$3.message,
                                  value: e$3.value
                                }
                              };
                      }
                      var e$4 = validatableRequestsAmount._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".validatableRequestsAmount" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                              }
                            };
                    }
                    var e$5 = unvalidatableRequestsAmount._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".unvalidatableRequestsAmount" + e$5.path,
                              message: e$5.message,
                              value: e$5.value
                            }
                          };
                  }
                  var e$6 = remainingResources._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".remainingResources" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                          }
                        };
                }
                var e$7 = finishedRequestsAmount._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".finishedRequestsAmount" + e$7.path,
                          message: e$7.message,
                          value: e$7.value
                        }
                      };
              }
              var e$8 = allocatedResources._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".allocatedResources" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                      }
                    };
            }
            var e$9 = nameMr._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".nameMr" + e$9.path,
                      message: e$9.message,
                      value: e$9.value
                    }
                  };
          }
          var e$10 = mr._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".mr" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
        }
        var e$11 = nameRmpc._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".nameRmpc" + e$11.path,
                  message: e$11.message,
                  value: e$11.value
                }
              };
      }
      var e$12 = rmpc._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".rmpc" + e$12.path,
                message: e$12.message,
                value: e$12.value
              }
            };
    }
    var e$13 = periodID._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".periodID" + e$13.path,
              message: e$13.message,
              value: e$13.value
            }
          };
  }
  var e$14 = year._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".year" + e$14.path,
            message: e$14.message,
            value: e$14.value
          }
        };
}

function poolExpensesList_encode(v) {
  return Decco.listToJson(poolExpense_encode, v);
}

function poolExpensesList_decode(v) {
  return Decco.listFromJson(poolExpense_decode, v);
}

function searchResult_encode(v) {
  return Js_dict.fromArray([
              [
                "content",
                Decco.listToJson(poolExpense_encode, v.content)
              ],
              [
                "total",
                Decco.intToJson(v.total)
              ]
            ]);
}

function searchResult_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var content = Decco.listFromJson(poolExpense_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "content"), null));
  if (content.TAG === /* Ok */0) {
    var total = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "total"), null));
    if (total.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                content: content._0,
                total: total._0
              }
            };
    }
    var e = total._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".total" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = content._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".content" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var PoolExpenses = {
  poolExpense_encode: poolExpense_encode,
  poolExpense_decode: poolExpense_decode,
  poolExpensesList_encode: poolExpensesList_encode,
  poolExpensesList_decode: poolExpensesList_decode,
  searchResult_encode: searchResult_encode,
  searchResult_decode: searchResult_decode
};

export {
  Fields ,
  PoolExpenses ,
}
/* App_Types_Date-DvmAdminFrontendFr Not a pure module */
